import { render, staticRenderFns } from "./AdvertClickList.vue?vue&type=template&id=2078f25c"
import script from "./AdvertClickList.vue?vue&type=script&lang=js"
export * from "./AdvertClickList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports